import * as React from 'react';

import './PracticeTestComponentSelector.css';

export interface Props {
    onSwitchComponent: () => void;
    displayName: string;
    active: boolean;
    optional?: boolean
}

const PracticeTestComponentSelector: React.SFC<Props> = (props: Props) => {
    let {optional=false} = props
    let buttonLabel = `${props.displayName} ${optional ? "(Optional)": ""}`

    return (
        <button
            className={'btn subject-btn btn-not-bold btn-default practice-test-component-selector ' +
            (props.active ? 'activeSelection arrow_box' : '')}
            type="button"
            onClick={() => props.onSwitchComponent()}
        >
            {buttonLabel}
        </button>
    );
};

export default PracticeTestComponentSelector;
